"use strict";
class BitmapFontData {
  constructor() {
    this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
  }
}
exports.BitmapFontData = BitmapFontData;
//# sourceMappingURL=BitmapFontData.js.map
